import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import FBMCredentials from "./FBM/FBMCredentials";
import FbmArticles from "./FBM/FBMArticles";
import FBMConfigurationTab from "./FBM/FBMConfiguration";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const ShopifyTab = ({ initialSku = null, onNavConsumed, onNavigateToBase }) => {
  const [shopifySubTab, setShopifySubTab] = useState(1);

  React.useEffect(() => {
    if (initialSku) {
      setShopifySubTab(1);
    }
  }, [initialSku]);

  const handleShopifySubTabChange = (event, newValue) => {
    setShopifySubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={shopifySubTab}
              onChange={handleShopifySubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Credentials" />
              <Tab label="Articles" />
              <Tab label="Configuration" />
            </Tabs>
          </Box>

          {/* FBM Credentials Tab */}
          <TabPanel value={shopifySubTab} index={0}>
            <FBMCredentials />
          </TabPanel>
          {/* Articles Tab */}
          <TabPanel value={shopifySubTab} index={1}>
            <FbmArticles
              initialSku={initialSku}
              onSkuConsumed={onNavConsumed}
              onNavigateToBase={onNavigateToBase}
            />
          </TabPanel>
          {/* Configuration Tab */}
          <TabPanel value={shopifySubTab} index={2}>
            <FBMConfigurationTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ShopifyTab;
